import {useEffect} from 'react';
import { Box } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

export default function ScrollToTopButton() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  return (
    <Box>

      {/* 👇️ scroll to top on button click */}
      <IconButton onClick={() => { window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });}}
  sx={{
    position: 'fixed',
    padding: '1rem 2rem',
    bottom: '40px',
    right: '05px',
    backgroundColor: '#424242',
    color: '#fff',
    width: '60px',
    '&:hover': {
      // Set hover styles to be the same as regular styles
      backgroundColor: '#424242',
      color: '#fff',
    },
  }}>
  <ArrowUpwardIcon />
</IconButton>

    </Box>
  );
}